import React, { ReactNode } from 'react'
import { Button } from 'react-bootstrap'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'

interface ErrorLayoutProps {
  code: string | number
  message: ReactNode
  note?: ReactNode
  onReset?: () => void
}

export function ErrorLayout({ code, message, note, onReset }: ErrorLayoutProps): JSX.Element {
  const { _t } = useTypedTranslation()

  return (
    <div className="container-fluid main-container">
      <div className="centered-layout error-page">
        <div className="error-box">
          <div className="error-code">{code}</div>
          <div className="error-message">{message}</div>
          {note && <div className="error-note text-muted text-center mb-4">{note}</div>}
          {onReset && (
            <Button variant="primary" onClick={onReset}>
              {_t('go-back')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
